import React, { useState, useEffect } from "react";
import { Alert, Image, ImageBackground, Modal, Platform, SafeAreaView, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import typo from "../../Theme/Typo";
import Colors from "../../Theme/Colors";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Checkbox, TextInput } from "react-native-paper";
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import Entypo from '@expo/vector-icons/Entypo';
import RootStore from "../../Store";
import ImageViewer from "react-native-image-zoom-viewer";

import { CheckBox } from 'react-native-web';
import AlertCustom from "../utils/alert";

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const { userInfo } = RootStore.getInstance()

const HistoryEvent = ({ navigation, route }) => {

    const [booking, setBooking] = useState({})
    const [todoList, setTodoList] = useState([])
    const [eventDetail, setEventDetails] = useState({});
    const [isViewer, setViewer] = useState({
        isVisible: false,
        index: 0
    })

    const fullView = true;

    const { bookingParams = {}, todoListParams = [], evenDetailParams = {}, checkoutInfo = {} } = route.params

    const { t, i18n } = useTranslation()

    useEffect(() => {
        setEventDetails(evenDetailParams)
        setTodoList(todoListParams)
        setBooking(bookingParams)
    }, [])

    const MultiselectCheckbox = ({ options }) => {
        return (
            <>
                {options.map((item, index) => (
                    <View style={style.item} key={index}>
                        {Platform.OS !== "web" ?
                            (<Checkbox.Android
                                color="#71d200"
                                uncheckedColor="red"
                                status={'checked'}
                            />)
                            :
                            (<CheckBox
                                color="#71d200"
                                value={true}
                                style={{ marginRight: 10 }}
                            />)
                        }
                        <Text style={style.textCheckBox} key={item.text}>{item.text}</Text>
                    </View>
                ))}
            </>
        );
    };

    const helpCheckoutInfo = () => {
        AlertCustom(t("EVENT_CHECKOUT_TITLE"), t("HELP_CHECKOUT_EVENT_INFO"))
    }

    return (
        <SafeAreaView style={typo.mainBackground}>
            <ImageBackground source={BG_PATH} style={typo.background}>
                <ScrollView>
                    <View style={typo.container}>
                        <Text style={typo.titleInfo}>{t("EVENT_TITLE")}</Text>
                        <View>
                            <View style={typo.resCard}>
                                <View style={typo.underlineCat}>
                                    <MaterialIcons name="info" size={25} style={{ marginRight: 10 }} color={Colors.oiqia} />
                                    <Text style={typo.category}>{t("EVENT_STATUS_TITLE")}</Text>
                                </View>
                                <View>
                                    {eventDetail.type === "cleaner" &&
                                        <View>
                                            <Text style={[typo.h1, style.newTitle]}><MaterialIcons style={{ marginRight: 10 }} name="cleaning-services" size={20} color={Colors.oiqia}></MaterialIcons> {eventDetail.title}</Text>
                                        </View>
                                    }
                                    {eventDetail.type === "maintainer" &&
                                        <View>
                                            <Text style={[typo.h1, style.newTitle]}><MaterialIcons style={{ marginRight: 10 }} name="build" size={20} color={Colors.oiqia}></MaterialIcons> {eventDetail.title}</Text>
                                        </View>
                                    }
                                    {eventDetail.type === "other" &&
                                        <View>
                                            <Text style={[typo.h1, style.newTitle]}><MaterialIcons style={{ marginRight: 10 }} name="flag" size={20} color={Colors.oiqia}></MaterialIcons> {eventDetail.title}</Text>
                                        </View>
                                    }
                                    <View style={{ marginTop: 3 }}>
                                        <Text style={typo.body}><MaterialIcons name="location-pin" size={18} color={Colors.black}></MaterialIcons>{eventDetail.nameOfAppart}</Text>
                                    </View>
                                </View>
                                {eventDetail.description != "" &&
                                    <View style={{ marginTop: 5, marginBottom: 5 }}>
                                        <Text style={style.newDesc}>{eventDetail.description}</Text>
                                    </View>
                                }
                                <View style={style.columnNew}>
                                    <View style={style.left}>
                                        <MaterialIcons name="calendar-today" color={Colors.oiqia} size={20}></MaterialIcons>
                                    </View>
                                    <View style={style.right}>
                                        <Text style={style.newDate}>
                                            {(eventDetail.start && eventDetail.end) &&
                                                <Text>
                                                    {format(new Date(eventDetail?.start), "dd/MM/yyyy ")}
                                                    {format(new Date(eventDetail?.start), "HH:mm")} → {format(new Date(eventDetail?.end), "HH:mm")}
                                                </Text>
                                            }
                                        </Text>
                                    </View>
                                </View>
                                {(eventDetail.statusOfEvent && eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value === "Évènement confirmé") &&
                                    <View style={style.columnNew}>
                                        <View style={style.left}>
                                            <MaterialIcons name="event-available" size={20} color={Colors.green} />
                                        </View>
                                        <View style={style.right}>
                                            <Text style={{ color: Colors.green }}>{eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value}</Text>
                                        </View>
                                    </View>
                                }
                                {(eventDetail.statusOfEvent && eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value === "Créé") &&
                                    <View style={style.columnNew}>
                                        <View style={style.left}>
                                            <MaterialIcons name="create" size={20} color={Colors.grey} />
                                        </View>
                                        <View style={style.right}>
                                            <Text style={{ color: Colors.grey }}>{eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value}</Text>
                                        </View>
                                    </View>
                                }
                                {(eventDetail.statusOfEvent && eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value === "Incident déclaré") &&
                                    <View style={style.columnNew}>
                                        <View style={style.left}>
                                            <MaterialIcons name="report-problem" size={20} color={Colors.red} />
                                        </View>
                                        <View style={style.right}>
                                            <Text style={{ color: Colors.red }}>{eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value}</Text>
                                        </View>
                                    </View>
                                }
                                {(eventDetail.statusOfEvent && eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value === "Fini") &&
                                    <View style={style.columnNew}>
                                        <View style={style.left}>
                                            <MaterialIcons name="check-circle-outline" size={20} color={Colors.green} />
                                        </View>
                                        <View style={style.right}>
                                            <Text style={{ color: Colors.green }}>{eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value}</Text>
                                        </View>
                                    </View>
                                }
                                {(eventDetail.statusOfEvent && eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value === "Annulé") &&
                                    <View style={style.columnNew}>
                                        <View style={style.left}>
                                            <MaterialIcons name="cancel" size={24} color={Colors.red} />
                                        </View>
                                        <View style={style.right}>
                                            <Text style={{ color: Colors.red }}>{eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value}</Text>
                                        </View>
                                    </View>
                                }

                            </View>

                            {eventDetail && eventDetail.type == 'cleaner' &&
                                <View style={typo.resCard}>
                                    <View style={typo.underlineCat}>
                                        <MaterialIcons name="bookmark-outline" size={24} style={{ marginRight: 10 }} color={Colors.oiqia} onPress={() => helpCheckoutInfo()} />
                                        <Text style={typo.category}>{t("EVENT_CHECKOUT_TITLE")}</Text>
                                    </View>
                                    {checkoutInfo.checkoutDone &&
                                        <>
                                            <Text style={{ marginTop: 5 }}>
                                                {t("EVENT_CHECKOUT_STATUS")}
                                                {checkoutInfo.checkoutDone && (!checkoutInfo.problem || (checkoutInfo.problem.description == "" && checkoutInfo.problem.image.length == 0)) &&
                                                    <Text style={{ color: Colors.green, fontWeight: "bold", alignItems: "center" }}> {t("CHECKOUT_DONE")} </Text>
                                                }
                                                {checkoutInfo.checkoutDone && checkoutInfo.problem && (checkoutInfo.problem.description != "" || checkoutInfo.problem.image.length > 0) &&
                                                    <Text style={{ color: Colors.orange, fontWeight: "bold", alignItems: "center" }}> {t("CHECKOUT_DONE_INCIDENT")} </Text>
                                                }
                                                {!(checkoutInfo.checkoutDone) &&
                                                    <Text style={{ color: Colors.red, fontWeight: "bold", alignItems: "center" }}> {t("CHECKOUT_UNDONE")} </Text>
                                                }
                                            </Text>
                                            <Text style={{ marginTop: 5 }}>
                                                {t("CHECKOUT_RATING_CLEANNESS")}
                                                {checkoutInfo.ratingCleanness != undefined && checkoutInfo.ratingCleanness == 5 &&
                                                    <Text style={{ color: Colors.oiqia, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.ratingCleanness}/5
                                                    </Text>
                                                }
                                                {checkoutInfo.ratingCleanness != undefined && checkoutInfo.ratingCleanness >= 3 && checkoutInfo.ratingCleanness < 5 &&
                                                    <Text style={{ color: Colors.oiqia, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.ratingCleanness}/5
                                                    </Text>
                                                }
                                                {checkoutInfo.ratingCleanness != undefined && checkoutInfo.ratingCleanness <= 2 && checkoutInfo.ratingCleanness > 0 &&
                                                    <Text style={{ color: Colors.oiqia, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.ratingCleanness}/5
                                                    </Text>
                                                }
                                                {checkoutInfo.ratingCleanness != undefined && checkoutInfo.ratingCleanness == 0 &&
                                                    <Text style={{ color: Colors.red, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.ratingCleanness}/5
                                                    </Text>
                                                }
                                                {checkoutInfo.ratingCleanness != undefined && checkoutInfo.ratingCleanness == -1 &&
                                                    <Text style={{ color: Colors.red, fontWeight: "bold", alignItems: "center" }}>
                                                        {t("UNKNOWN_UNDONE")}
                                                    </Text>
                                                }
                                            </Text>
                                            {fullView &&
                                                <>
                                                    <Text>
                                                        {t("CHECKOUT_RATING_APPART")}
                                                        <Text style={{ color: Colors.oiqia, fontWeight: "bold", alignItems: "center" }}>
                                                            {checkoutInfo.ratingAppart}/5
                                                        </Text>
                                                    </Text>
                                                    <Text>
                                                        {t("CHECKOUT_RATING_OIQIA")}
                                                        <Text style={{ color: Colors.oiqia, fontWeight: "bold", alignItems: "center" }}>
                                                            {checkoutInfo.ratingOiqia}/5
                                                        </Text>
                                                    </Text>
                                                </>
                                            }
                                            <Text style={{ marginTop: 5 }}>
                                                {t("CHECKOUT_FEEDBACK")}
                                                {checkoutInfo.feedBack != undefined && checkoutInfo.feedBack.length > 20 && fullView &&
                                                    <Text style={{ color: Colors.grey, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.feedBack}
                                                    </Text>
                                                }
                                                {checkoutInfo.feedBack != undefined && checkoutInfo.feedBack.length > 20 && !fullView &&
                                                    <Text style={{ color: Colors.grey, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.feedBack.substring(0, 12)} ...
                                                    </Text>
                                                }
                                                {checkoutInfo.feedBack != undefined && checkoutInfo.feedBack.length < 20 &&
                                                    <Text style={{ color: Colors.grey, fontWeight: "bold", alignItems: "center" }}>
                                                        {checkoutInfo.feedBack}
                                                    </Text>
                                                }
                                                {checkoutInfo.feedBack != undefined && checkoutInfo.feedBack == "" && checkoutInfo.checkoutDone &&
                                                    <Text style={{ color: Colors.red, fontWeight: "bold", alignItems: "center" }}>
                                                        {t("UNKNOWN")}
                                                    </Text>
                                                }
                                                {checkoutInfo.feedBack != undefined && checkoutInfo.feedBack == "" && !checkoutInfo.checkoutDone &&
                                                    <Text style={{ color: Colors.red, fontWeight: "bold", alignItems: "center" }}>
                                                        {t("UNKNOWN_UNDONE")}
                                                    </Text>
                                                }
                                            </Text>
                                        </>}
                                    {!checkoutInfo.checkoutDone &&
                                        <Text style={{ color: Colors.red, fontWeight: "bold", alignItems: "center" }}>
                                            {t("UNKNOWN_UNDONE_TRAVELER")}
                                        </Text>
                                    }
                                    {fullView && checkoutInfo && checkoutInfo.problem && checkoutInfo.problem.image && checkoutInfo.problem.description && (checkoutInfo.problem.description != "" || checkoutInfo.problem.image.length > 0) &&
                                        <View style={{ marginTop: 10 }}><Text>{t("CHECKOUT_PICTURE_INCIDENT")} <Text style={{ color: Colors.red, fontWeight: "800", marginBottom: 10 }}>{checkoutInfo.problem.description ? checkoutInfo.problem.description : t("CHECKOUT_INCIDENT_DESCRIPTION_NULL")}</Text></Text>
                                            <View style={typo.catCard}>
                                                <ScrollView horizontal>
                                                    {checkoutInfo.problem.image.length > 0 ?
                                                        checkoutInfo.problem.image.map((element, index) => (
                                                            <View style={{ margin: 5 }} key={index}>
                                                                <Image
                                                                    style={style.image}
                                                                    source={{ uri: element }}
                                                                />
                                                            </View>
                                                        ))
                                                        :
                                                        <View>
                                                            <Text style={[typo.body, { alignSelf: "center" }]}>{t("PROBLEM_PICTURES_EMPTY")}</Text>
                                                        </View>
                                                    }
                                                </ScrollView>
                                            </View>
                                        </View>
                                    }

                                </View>
                            }

                            {(( /* L'event n'a pas été annulé */eventDetail.statusOfEvent && eventDetail?.statusOfEvent[eventDetail?.statusOfEvent.length - 1].value !== "Annulé") && (/*ou l'event est de type intervention ou autre */eventDetail.type === "cleaner")) &&
                                <View style={typo.resCard}>
                                    <View style={typo.underlineCat}>
                                        <MaterialIcons name="done" size={25} style={{ marginRight: 10 }} color={Colors.oiqia} />
                                        <Text style={typo.category}>{t("EVENT_TODO_TITLE")}</Text>
                                    </View>
                                    <MultiselectCheckbox options={todoList} />
                                </View>
                            }
                            {(eventDetail.problems) ?
                                <View style={typo.resCard}>
                                    <View style={typo.underlineCat}>
                                        <MaterialIcons name="report-problem" size={25} style={{ marginRight: 10 }} color={Colors.oiqia} />
                                        <Text style={typo.category}>{t("EVENT_PROBLEM_TITLE")}</Text>
                                    </View>
                                    <View>
                                        {eventDetail.problems &&
                                            <View>
                                                <TextInput
                                                    disabled
                                                    value={eventDetail.problems.title}
                                                    label={t("PROBLEM_TITLE_LABEL")}
                                                    style={{ marginTop: 10, marginBottom: 10, backgroundColor: "white" }}
                                                    mode="outlined"
                                                />
                                                <TextInput
                                                    disabled
                                                    value={eventDetail.problems.description}
                                                    label={t("PROBLEM_DESCRIPTION_LABEL")}
                                                    style={{ marginTop: 10, marginBottom: 10, backgroundColor: "white" }}
                                                    mode="outlined"
                                                />
                                                <ScrollView horizontal style={typo.catCard}>
                                                    {eventDetail.problems.image && eventDetail.problems.image.length > 0 ?
                                                        eventDetail.problems.image.map((problem, index) => {
                                                            return (<TouchableOpacity key={index} style={{ margin: 5 }} onPress={() => setViewer({ isVisible: true, index })}>
                                                                <Image
                                                                    style={style.image}
                                                                    source={{ uri: problem }}
                                                                />
                                                            </TouchableOpacity>)
                                                        })
                                                        :
                                                        <View style={{ alignSelf: "center" }}>
                                                            <Text>{t("EVENT_PROBLEM_PICTURE_EMPTY")}</Text>
                                                        </View>}
                                                </ScrollView>
                                            </View>

                                        }
                                    </View>
                                    {(Platform.OS != "web" && eventDetail.problems && eventDetail?.problems.image.length > 0) &&
                                        <SafeAreaView style={{ flex: 1 }}>
                                            <Modal visible={isViewer.isVisible} transparent={true}>
                                                <ImageViewer
                                                    enableSwipeDown={true}
                                                    index={isViewer.index}
                                                    imageUrls={eventDetail?.problems.image.map(ele => {
                                                        return {
                                                            url: ele,
                                                            props: { source: ele },
                                                        };
                                                    })}
                                                    renderHeader={() => (
                                                        <SafeAreaView>
                                                            <TouchableOpacity onPress={() => setViewer({ isVisible: false, index: 0 })}>
                                                                <Entypo
                                                                    name="cross"
                                                                    onPress={() => setViewer({ isVisible: false, index: 0 })}
                                                                    size={60}
                                                                    color="white"
                                                                />
                                                            </TouchableOpacity>
                                                        </SafeAreaView>
                                                    )}
                                                ></ImageViewer>
                                            </Modal>
                                        </SafeAreaView>
                                    }
                                </View>
                                :
                                <View style={typo.resCard}>
                                    <Text>{t("EVENT_PROBLEM_EMPTY")}</Text>
                                </View>
                            }
                        </View>
                    </View>
                </ScrollView>
            </ImageBackground>
        </SafeAreaView>
    )
}

const style = StyleSheet.create({
    newDate: {
        fontWeight: 'bold',
        color: Colors.oiqia,
        textAlignVertical: "center"
    },
    newDesc: {
        color: Colors.black,
        fontStyle: 'italic',
        fontSize: 18
    },
    newTitle: {
        color: Colors.oiqia
    },
    columnNew: {
        flex: 1,
        alignSelf: "flex-start",
        flexDirection: "row",
        marginTop: 10
    },
    left: {
        alignSelf: 'flex-start'
    },
    right: {
        marginLeft: 5,
        alignSelf: 'flex-end'
    },
    center: {
        flex: 1,
        justifyContent: "flex-end",
    },
    titleWelcome: {
        fontSize: 18,
        color: "black",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "RobotoMedium"
    },
    container: {
        flex: 1,
        backgroundColor: "#fff",
    },
    column: {
        flex: 1,
        alignSelf: "auto",
        justifyContent: "space-between",
        flexDirection: "row",
    },
    dateInfo: {
        width: "50%",
        padding: 5,
        textAlign: "left",

        justifyContent: "flex-start",
    },
    underline: {
        borderColor: "#0A0A0AE7",
        borderBottomWidth: 0.5,
        paddingBottom: 5,
        marginBottom: 10
    },
    item: {
        marginTop: 10,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center"
    },
    textCheckBox: {
        maxWidth: 320
    },
    image: {
        left: 5,
        top: 5,
        width: 200,
        height: 150,
        borderWidth: 1,
        borderRadius: 1,
        marginRight: 10,
        borderColor: "white",
        marginBottom: 5,
    }
})

export default HistoryEvent;